<template lang="pug">
.audio-player
  .playback
    a.control(@click="togglePlayback")
      b-icon(
        :icon="playing ? 'pause' : 'play'"
      )
      //- a.button.is-small(@click="stop")
      //-   b-icon(icon="stop")
    small.timecode.seek {{ seek | timecode }}
    span.scrubber
      progress.progress.is-small.is-primary(
        :value="progress * 100"
        max="100"
        @click="scrub"
      )
    small.timecode.duration {{ duration | timecode }}
    b-field
      a.control(@click="confirm")
        b-icon(icon="close")
      //- a.button.is-light(:href="audio.download_link")
      //-   b-icon(icon="download")
</template>

<script>
import VueHowler from 'vue-howler';

export default {
  name: 'audio-player',
  mixins: [
    VueHowler,
  ],
  methods: {
    confirm() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this audio file cannot be undone.',
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Yes, Delete Audio',
        onConfirm: () => this.$emit('delete-audio'),
      });
    },
    scrub($event) {
      const xPos = $event.layerX;
      const totalWidth = $event.srcElement.clientWidth;
      const prog = xPos / totalWidth;
      this.setProgress(prog);
    },
  },
  props: {
    audio: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-player {
  background-color: $white-ter;
  padding: 6px;
  border-radius: 4px;
  .playback {
    display: flex;
    align-items: center;
    .control {
      top: 2px;
      position: relative;
      color: $grey;
      &:hover {
        color: $grey;
      }
    }
    .timecode {
      width: 70px;
      text-align: right;
      font-family: 'Roboto Mono', monospace;
      font-size: 0.7rem;
      color: $grey;
      &.seek {
        text-align: right;
      }
    }
    .scrubber {
      width: 100%;
      margin: 0 8px;
      progress {
        border-radius: 0;
        height: 4px;
        margin: 0;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AudioPlayer.vue